export default "__VITE_ASSET__CDM1b6l4__"